export default __webpack_public_path__ + "static/media/Invent_logo_White.18cb3c94.png";